import { render, staticRenderFns } from "./EditCustomerForm.vue?vue&type=template&id=9cb78134"
import script from "./EditCustomerForm.vue?vue&type=script&lang=js"
export * from "./EditCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./EditCustomerForm.vue?vue&type=style&index=0&id=9cb78134&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports